/** Customize fields → {{THEME.*}} color tokens (full skin contract). */
export const MODES_FILL = ["solid", "gradient"];
export const MODES_TEXT = ["solid", "gradient"];
export const MODES_SOLID = ["solid"];

export const CUSTOMIZE_FIELDS = [
    // Surfaces
    {
        key: "background",
        label: "Background",
        group: "Surfaces",
        allowedModes: MODES_FILL,
    },
    {
        key: "headerBackground",
        label: "Header background",
        group: "Surfaces",
        allowedModes: MODES_FILL,
    },
    {
        key: "backgroundAccent",
        label: "Body background",
        group: "Surfaces",
        allowedModes: MODES_FILL,
    },
    {
        key: "footerBackground",
        label: "Footer background",
        group: "Surfaces",
        allowedModes: MODES_FILL,
    },
    {
        key: "separator",
        label: "Separator",
        group: "Surfaces",
        allowedModes: MODES_SOLID,
    },
    // Text
    {
        key: "headingText",
        label: "Heading text",
        group: "Text",
        allowedModes: MODES_TEXT,
    },
    {
        key: "textDescription",
        label: "Description",
        group: "Text",
        allowedModes: MODES_TEXT,
    },
    {
        key: "textColor",
        label: "Body text",
        group: "Text",
        allowedModes: MODES_TEXT,
    },
    {
        key: "textColorMuted",
        label: "Body text muted",
        group: "Text",
        allowedModes: MODES_TEXT,
    },
    {
        key: "textDiscount",
        label: "Body discount text",
        group: "Text",
        allowedModes: MODES_TEXT,
    },
    {
        key: "footerTextColor",
        label: "Footer text",
        group: "Text",
        allowedModes: MODES_SOLID,
    },
    // Text links (e.g. SEE ALL)
    {
        key: "colorLink",
        label: "Link color",
        group: "Links",
        allowedModes: MODES_SOLID,
    },
    {
        key: "colorLinkHover",
        label: "Link hover color",
        group: "Links",
        allowedModes: MODES_SOLID,
    },
    // Secondary / shop
    {
        key: "btnShopBg",
        label: "Shop button bg",
        group: "Shop button",
        allowedModes: MODES_FILL,
    },
    {
        key: "btnShopColor",
        label: "Shop button label",
        group: "Shop button",
        allowedModes: MODES_SOLID,
    },
    {
        key: "btnShopBorder",
        label: "Shop button border",
        group: "Shop button",
        allowedModes: MODES_SOLID,
    },
    {
        key: "btnShopBgHover",
        label: "Shop hover bg",
        group: "Shop button",
        allowedModes: MODES_FILL,
    },
    {
        key: "btnShopColorHover",
        label: "Shop hover label",
        group: "Shop button",
        allowedModes: MODES_SOLID,
    },
    {
        key: "btnShopBorderHover",
        label: "Shop hover border",
        group: "Shop button",
        allowedModes: MODES_SOLID,
    },
    // Track order CTA
    {
        key: "btnTrackBg",
        label: "Button / accent",
        group: "Track button",
        allowedModes: MODES_FILL,
    },
    {
        key: "btnTrackColor",
        label: "Button label",
        group: "Track button",
        allowedModes: MODES_SOLID,
    },
    {
        key: "btnTrackBorder",
        label: "Button border",
        group: "Track button",
        allowedModes: MODES_SOLID,
    },
    {
        key: "btnTrackBgHover",
        label: "Button hover bg",
        group: "Track button",
        allowedModes: MODES_FILL,
    },
    {
        key: "btnTrackColorHover",
        label: "Button hover label",
        group: "Track button",
        allowedModes: MODES_SOLID,
    },
    {
        key: "btnTrackBorderHover",
        label: "Button hover border",
        group: "Track button",
        allowedModes: MODES_SOLID,
    },
    // Status tracker
    {
        key: "statusBgActive",
        label: "Status active bg",
        group: "Status",
        allowedModes: MODES_FILL,
    },
    {
        key: "statusIconActive",
        label: "Status active icon",
        group: "Status",
        allowedModes: MODES_SOLID,
    },
    {
        key: "statusColorActive",
        label: "Status active label",
        group: "Status",
        allowedModes: MODES_TEXT,
    },
    {
        key: "statusBgInactive",
        label: "Status inactive bg",
        group: "Status",
        allowedModes: MODES_FILL,
    },
    {
        key: "statusIconInactive",
        label: "Status inactive icon",
        group: "Status",
        allowedModes: MODES_SOLID,
    },
    {
        key: "statusColorInactive",
        label: "Status inactive label",
        group: "Status",
        allowedModes: MODES_TEXT,
    },
    {
        key: "dotActive",
        label: "Dot active",
        group: "Status",
        allowedModes: MODES_SOLID,
    },
    {
        key: "dotInactive",
        label: "Dot inactive",
        group: "Status",
        allowedModes: MODES_SOLID,
    },
    // Bag icon (SVG → PNG pipeline — solid only)
    {
        key: "bagBaseColor",
        label: "Bag base",
        group: "Bag icon",
        allowedModes: MODES_SOLID,
    },
    {
        key: "bagTraceBaseColor",
        label: "Bag trace",
        group: "Bag icon",
        allowedModes: MODES_SOLID,
    },
    {
        key: "bagSideColor",
        label: "Bag side",
        group: "Bag icon",
        allowedModes: MODES_SOLID,
    },
    {
        key: "bagLateralStroke",
        label: "Bag lateral stroke",
        group: "Bag icon",
        allowedModes: MODES_SOLID,
    },
    {
        key: "bagFrontBag",
        label: "Bag front",
        group: "Bag icon",
        allowedModes: MODES_SOLID,
    },
    {
        key: "bagSignal",
        label: "Bag signal",
        group: "Bag icon",
        allowedModes: MODES_SOLID,
    },
    {
        key: "bagShadow",
        label: "Bag shadow",
        group: "Bag icon",
        allowedModes: MODES_SOLID,
    },
    {
        key: "bagCounterBadge",
        label: "Bag badge",
        group: "Bag icon",
        allowedModes: MODES_SOLID,
    },
    {
        key: "bagTextCounterBadge",
        label: "Bag badge text",
        group: "Bag icon",
        allowedModes: MODES_SOLID,
    },
    {
        key: "bagStrap",
        label: "Bag strap",
        group: "Bag icon",
        allowedModes: MODES_SOLID,
    },
    // Decline illustration (Order Declined only — SVG → PNG pipeline)
    {
        key: "declinedInk",
        label: "Window outline",
        group: "Decline art",
        allowedModes: MODES_SOLID,
    },
    {
        key: "declinedMark",
        label: "Decline mark",
        group: "Decline art",
        allowedModes: MODES_SOLID,
    },
    {
        key: "declinedButton",
        label: "Art button",
        group: "Decline art",
        allowedModes: MODES_SOLID,
    },
    // Social icon tint
    {
        key: "footerIconColor",
        label: "Social icons",
        group: "Icon Social",
        allowedModes: MODES_SOLID,
    },
];
